import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TGenericCodebookItem {
  id: number;
  code: string;
  type: string;
  value: string;
  valid: boolean;
}

export interface IGenericCodebookItem extends TGenericCodebookItem {}

const GenericCodebookItem = Model(
  (model: TGenericCodebookItem): IGenericCodebookItem => {
    const _genericCodebookItem: TGenericCodebookItem = Object.assign({}, model);

    let create = (
      genericCodebookItem: IGenericCodebookItem
    ): IGenericCodebookItem => {
      let obj = ValidatableObject(genericCodebookItem);
      return obj;
    };

    let genericCodebookItem = {
      get id() {
        return _genericCodebookItem.id;
      },
      set id(value) {
        _genericCodebookItem.id = value;
      },
      get code() {
        return _genericCodebookItem.code;
      },
      set code(value) {
        _genericCodebookItem.code = value;
      },

      get type() {
        return _genericCodebookItem.type;
      },
      set type(value) {
        _genericCodebookItem.type = value;
      },
      get value() {
        return _genericCodebookItem.value;
      },
      set value(value) {
        _genericCodebookItem.value = value;
      },
      get valid() {
        return _genericCodebookItem.valid;
      },
      set valid(value) {
        _genericCodebookItem.valid = value;
      }
    };

    return create(genericCodebookItem);
  }
);

export default GenericCodebookItem;
